module.exports = __webpack_public_path__ + "img/im.ac0c825e.svg";